import type {Agent} from 'api/types';
import type {SchemaModifier} from 'schemaDefinition/types';

export const getAgentSchemaModifiers = (
  agent: Agent | undefined,
): SchemaModifier[] => {
  const modifiers: SchemaModifier[] = [];
  if (!agent) {
    return modifiers;
  }

  return modifiers;
};
